/* eslint-disable no-underscore-dangle */
import React, { Component } from "react";
import Input from "components/Global-2016/Forms/Input";
import PropTypes from "prop-types";
import Checkbox from "rc-checkbox";
import InsertTemplate from "./InsertTemplate";
import { values, get } from "lodash";
import MergeMenu from "./MergeMenu";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import {
  MESSAGE_WYSIWYG_EDITOR_FIELD_ID,
  MAX_LENGTH_SMS
} from "SendEmailModal/constants";
import { AdvancedWYSIWYG } from "ui-kit/Form/View/AdvancedWYSIWYG";
import {
  DEFAULT_MODULES,
  DEFAULT_FORMATS
} from "ui-kit/Form/View/AdvancedWYSIWYG";
@CSSModules(css)
class EmailTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tag: undefined
    };
  }
  componentDidMount() {
    this.props.getEmailTemplates(
      this.props.orgId,
      this.props.eventId,
      this.props.moduleId
    );
  }

  handleTemplateSelect = id => {
    const template = get(this.props.templates, [id], {});
    this.props.updateMessage(
      template.content_formatted,
      template.content_plaintext
    );
    if (this.props.showSubject) {
      this.props.updateSubject(template.subject);
    }
    if (this.props.updateReplyTo && template.reply_to) {
      this.props.updateReplyTo(template.reply_to);
    }

    if (this.props.updateAttachments) {
      this.props.updateAttachments(template.attachments);
    }
  };

  handleTitleChange = e => this.props.updateTemplateTitle(e.target.value);
  handleSubjectChange = e => this.props.updateSubject(e.target.value);

  onMergeTagSelect = tag => {
    this.setState({ tag });
  };

  render() {
    const {
      templates,
      newTemplate,
      message,
      toggleTemplate,
      height,
      showSubject,
      showTemplates,
      useWYSIWYG,
      subject,
      mergeTags,
      mode,
      advancedWYSIWYGFieldId = MESSAGE_WYSIWYG_EDITOR_FIELD_ID
    } = this.props;

    const placeholder =
      mode === "sms"
        ? `Enter a message with a maximum length of ${MAX_LENGTH_SMS} characters`
        : "Enter a message ...";

    return (
      <div className={css.container}>
        <div className={css.topToolbar}>
          {showTemplates ? (
            <InsertTemplate
              onTemplateSelect={this.handleTemplateSelect}
              templates={values(templates)}
              orgId={this.props.orgId}
              eventId={this.props.eventId}
            />
          ) : null}
          {mergeTags.length ? (
            <MergeMenu
              mergeTags={mergeTags}
              onMergeTagSelect={this.onMergeTagSelect}
            />
          ) : (
            ""
          )}
        </div>
        <div styleName="inputWrapper">
          {showSubject ? (
            <div styleName="subjectWrapper">
              <Input
                onChange={this.handleSubjectChange}
                name="subject"
                containerStyles={css.subject}
                placeholder="Enter your email subject..."
                required
                value={subject}
              />
            </div>
          ) : (
            ""
          )}
          <AdvancedWYSIWYG
            tag={this.state.tag}
            value={message}
            fieldId={advancedWYSIWYGFieldId}
            width={"100%"}
            height={height}
            iniValue={message}
            useWYSIWYG={useWYSIWYG}
            placeholder={placeholder}
            maxLength={mode === "sms" ? MAX_LENGTH_SMS : null}
            settings={{
              valid_children: "+body[style]",
              plugins: DEFAULT_MODULES,
              toolbar: DEFAULT_FORMATS
            }}
          />
        </div>

        {toggleTemplate ? (
          <label styleName="saveTemplate">
            <Checkbox
              name="newTemplate"
              className={css.checkbox}
              onChange={toggleTemplate}
              checked={newTemplate}
            />
            <span styleName="checkboxLabel">Save as new template</span>
          </label>
        ) : null}

        {newTemplate ? (
          <div styleName="well">
            <Input
              onChange={this.handleTitleChange}
              label="Template Name"
              name="templateTitle"
              containerStyles={css.inputGroup}
              required
            />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

EmailTemplate.defaultProps = {
  height: 200,
  showSubject: false,
  updateSubject: () => {},
  subject: "",
  mergeTags: []
};

EmailTemplate.propTypes = {
  mergeTags: PropTypes.array.isRequired,
  subject: PropTypes.string.isRequired,
  showSubject: PropTypes.bool.isRequired,
  height: PropTypes.bool.isRequired,
  newTemplate: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  updateMessage: PropTypes.func.isRequired,
  updateTemplateTitle: PropTypes.func.isRequired,
  updateSubject: PropTypes.func,
  toggleTemplate: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(PropTypes.object).isRequired,
  getEmailTemplates: PropTypes.func.isRequired,
  updateReplyTo: PropTypes.func
};

export default EmailTemplate;
